import type { FilterMode } from "./type.ts";

export const activeConfiguration: { mode: FilterMode; activeFilterId?: string } = $state({
  mode: "default",
  activeFilterId: undefined,
});

export function setActiveConfiguration(mode: FilterMode, activeFilterId?: string) {
  activeConfiguration.mode = mode;
  activeConfiguration.activeFilterId = activeFilterId;
}
